import { render } from "./Pendings.vue?vue&type=template&id=dbdf8f10&scoped=true"
import script from "./Pendings.vue?vue&type=script&lang=js"
export * from "./Pendings.vue?vue&type=script&lang=js"

import "./Pendings.vue?vue&type=style&index=0&id=dbdf8f10&scoped=true&lang=scss"
import "./Pendings.vue?vue&type=style&index=1&id=dbdf8f10&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbdf8f10"]])

export default __exports__